import QuestionScreen from './scenes/QuestionScreen';
import IntroScreen from './scenes/IntroScreen';
import DragOrderScreen from './scenes/DragOrderScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [DragOrderScreen, QuestionScreen, IntroScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  INSTRUCTIONS1_SEEN: false,
  INSTRUCTIONS2_SEEN: false,
  muteJingle: false
};
